/** @format */

import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterComponent from "../../Components/Applications/ECommerce/Common/FilterComponent";
import { useSelector, useDispatch } from "react-redux";
import { Badge, Container } from "reactstrap";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import {
  deleteCashier,
  fetchCashiers,
} from "../../ReduxToolkit/Reducers/AppReducer";
import { Link } from "react-router-dom";
import SvgIcon from "../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import {
  openView,
  openViewWithParams,
} from "../../ReduxToolkit/Reducers/viewReducer";

export default function CashierList() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCashiers());
  }, [dispatch]);

  const [filterText, setFilterText] = useState("");
  const { vendorCashiers } = useSelector((state) => state.app);
  const filteredItems = (vendorCashiers || []).filter((item) => {
    return Object.values(item).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase())
    );
  });

  const getRole = (role) => {
    if ("wc_product_vendors_manager_vendor" === role) return "Vendor Manager";
    if ("wc_product_vendors_admin_vendor" === role) return "Vendor Admin";
  };

  const categoryColumns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      cell: (row) => <p>{row.id}</p>,
      width: "5%",
    },
    {
      name: "Name",
      selector: (row) => row.first_name,
      sortable: true,
      cell: (row) => (
        <p>
          {`${row.first_name} ${row.last_name}`}{" "}
          <Badge color="primary">{getRole(row.role)}</Badge>
        </p>
      ),
      width: "20%",
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      cell: (row) => <p>{row.email}</p>,
      width: "20%",
    },
    {
      name: "POS Code",
      selector: (row) => row.pos_code,
      sortable: true,
      cell: (row) => <p>{row.pos_code}</p>,
      width: "15%",
    },
    {
      name: "Password",
      selector: (row) => row.password,
      sortable: false,
      cell: (row) => <p>{row.password}</p>,
      width: "15%",
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="product-action">
          <Link
            onClick={() =>
              dispatch(
                openViewWithParams({
                  view: "cashiers_edit",
                  params: { cashier_id: row.id },
                })
              )
            }
          >
            <SvgIcon iconId="edit-content" />
          </Link>
          <SvgIcon iconId="trash1" onClick={() => handleDeleteCashier(row)} />
        </div>
      ),
      sortable: false,
      width: "15%",
    },
  ];

  const handleDeleteCashier = async (cashier) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--theme-red)",
      cancelButtonColor: "var(--theme-blue)",
      confirmButtonText: "Yes, delete it!",
    });
    if (result.isConfirmed) {
      try {
        dispatch(deleteCashier(cashier.id));
        toast.success("Cashier Deleted");
      } catch (error) {
        console.log(error);
        toast.error("Error Deleting Cashier");
      }
    }
  };

  return (
    <div className="page-body main-project">
      <Container fluid className="mt-3">
        <div className="list-product list-category">
          <div className="d-flex justify-content-between">
            <FilterComponent
              onFilter={(e) => setFilterText(e.target.value)}
              filterText={filterText}
            />
            <Link
              role="button"
              className="btn btn-primary"
              onClick={() => dispatch(openView("cashiers_new"))}
            >
              Add New
            </Link>
          </div>
          <DataTable
            className="custom-scrollbar"
            data={filteredItems}
            columns={categoryColumns}
            pagination
          />
        </div>
      </Container>
    </div>
  );
}
